<template>
  <div class="container-fluid" v-if="open">
    <div class="row">
      <div class="col-12 my-2 p-0">
        <div class="row mb-3">
          <div class="col-8 p-0">
            <div class="font-weight-bold text-cello d-flex align-items-center justify-content-between">
              Producer
              <el-input v-model="businesses_search" class="w-50" size="mini" placeholder="Search producer"></el-input>
            </div>
            <div style="height: 300px;overflow-y: auto;overflow-x: hidden;" class="mt-1 shadow-sm p-2 bg-white rounded">
              <el-checkbox-group v-model="business_ids">
                <el-checkbox class="w-100 m-0"
                  v-for="business in businesses.filter(data => !businesses_search || data.name.toLowerCase().includes(businesses_search.toLowerCase()))"
                  :key="business.id" :label="business.id">{{ business.name }}</el-checkbox>
              </el-checkbox-group>
              <p class="mt-2" v-if="businesses_loading">Loading...</p>
            </div>
          </div>
          <div class="col-2">
            <div class="row">
              <div class="col-12">
                <div class="font-weight-bold text-cello">Start Date</div>
                <div class="mt-2 shadow-sm p-2 bg-white rounded">
                  <el-date-picker size="mini" type="daterange" class="w-100" v-model="start_date" placeholder="Date"
                    value-format="yyyy-MM-dd" format="dd-MM-yyyy" />
                </div>

                <div class="font-weight-bold text-cello">Stock</div>
                <div class="mt-2 shadow-sm p-2 bg-white rounded">
                  <el-checkbox-group v-model="stock_ids">
                    <el-checkbox class="w-100" v-for="stock in livestock_classes" :key="stock.id" :label="stock.id">
                      {{ stock.name }}
                    </el-checkbox>
                  </el-checkbox-group>
                </div>

                <div class="font-weight-bold text-cello">Expiry</div>
                <div class="mt-2 shadow-sm p-2 bg-white rounded">
                  <el-radio-group v-model="expiry_id">
                    <el-radio class="w-100" v-for="item in expiry_dates" :key="item.id" :label="item.id">
                      {{ item.name }}
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
            </div>
          </div>
          <div class="col-2">
            <div class="row">
              <div class="col-12">
                <div class="font-weight-bold text-cello">Due Date</div>
                <div class="mt-2 shadow-sm p-2 bg-white rounded">
                  <el-date-picker size="mini" type="daterange" class="w-100" v-model="due_date" placeholder="Date"
                    value-format="yyyy-MM-dd" format="dd-MM-yyyy" />
                </div>

                <div class="font-weight-bold text-cello">Open/Closed</div>
                <div class="mt-2 shadow-sm p-2 bg-white rounded">
                  <el-checkbox-group v-model="status_ids">
                    <el-checkbox class="w-100" v-for="status in statuses" :key="status.id" :label="status.id">
                      {{ status.name }}
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 text-right">
            <el-button class="action-btn w-5 mt-2 rounded" type="info" style="width: 65px;"
              @click="clearSearch">Clear</el-button>
            <el-button class="action-btn w-5 mt-2 rounded" type="primary" style="width: 65px;"
              @click="handleFilterChange">Search</el-button>
            <el-button class="action-btn w-5 mt-2 rounded" type="danger" style="width: 65px;"
              @click="open = !open">Close</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Business from "../../../modelsPortal/Business";
export default {
  props: {

  },
  data() {
    return {
      businesses: [],
      businesses_search: '',
      statuses: [],
      businesses_loading: false,
      business_ids: [],
      stock_ids: [],
      status_ids: [1],
      expiry_id: null,
      due_date: null,
      start_date: null,
      livestock_classes: [
        { id: 1, name: 'Cattle' },
        { id: 2, name: 'Sheep' },
      ],
      statuses: [
        { id: 1, name: 'Open' },
        { id: 2, name: 'Closed' },
      ],
      expiry_dates: [
        { id: 1, name: 'Past' },
        { id: 2, name: 'Next Week' },
        { id: 3, name: 'Next Month' },
        { id: 4, name: 'Next Year' },
      ],
      open: false,
      dof: [0, 0],
      dof_ini: 0,
      dof_end: 0,
    };
  },
  created() {
    this.getBusinesses();
  },
  mounted() {
    this.$root.$on('openFilter', () => {
      this.open = !this.open;
    });
  },
  methods: {
    changePoints(event) {
      this.dof_ini = this.dof[0];
      this.dof_end = this.dof[1];
    },
    changeSlide() {
      this.dof = [this.dof_ini, this.dof_end];
    },
    clearSearch(refresh = true) {
      this.agency_ids = [];
      this.business_ids = [];
      this.stock_ids = [];
      this.status_ids = [1];
      this.due_date = null;
      this.start_date = null;
      this.dof = [0, 0];
      this.dof_ini = 0;
      this.dof_end = 0;
      this.expiry_id = null;
      if (refresh)
        this.handleFilterChange();
    },
    handleFilterChange() {
      let filter = {
        business_ids: this.business_ids.join(','),
        stock_ids: this.stock_ids.join(','),
        status_ids: this.status_ids.join(','),
        due_date: this.due_date,
        start_date: this.start_date,
        expiry_id: this.expiry_id,
        dof: this.dof.join(','),
      };

      this.$emit("filterSelected", filter);
    },
    getBusinesses() {
      this.businesses_loading = true;
      Business.params({ no_paginate: true })
        .select('id', 'name')
        .orderBy("name")
        .get()
        .then(res => {
          this.businesses = res;
          this.businesses_loading = false;
        })
        .catch(errors => {
          this.$message({
            type: "error",
            message: "Looks like something went wrong."
          });
        });
    },
  }
};
</script>
<style>
.filter-slider .el-slider__stop {
  background: transparent !important;
}

.separator {
  display: flex;
  align-items: center;
  text-align: center;
}

.separator::before,
.separator::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #e4e7ea;
}

.separator:not(:empty)::before {
  margin-right: .25em;
}

.separator:not(:empty)::after {
  margin-left: .25em;
}
</style>